import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { DatePipe } from "@angular/common";

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

import { UserService } from "../../../shared/services/user.service";
import { PersonSelectorService } from "../../personselector/personselector.service";

import { DataService_mealassignment } from "./shared/data.service";

import { wsMealAssignmentMealSubsidyTypeInfo } from "./shared/wsMealAssignmentMealSubsidyTypeInfo";
import { wsMealAssignmentStudentDataParmInfo } from "./shared/wsMealAssignmentStudentDataParmInfo";
import { wsMealAssignmentSelectedStudentsInfo } from "./shared/wsMealAssignmentStudentDataParmInfo";

import { wsMealAssignmentStudentDataInfo } from "./shared/wsMealAssignmentStudentDataInfo";
import { wsMealAssignmentStudentUnassignedInfo } from "./shared/wsMealAssignmentStudentDataInfo";
import { wsMealAssignmentStudentAssignedInfo } from "./shared/wsMealAssignmentStudentDataInfo";

import { wsMealAssignmentMealSubsidyTypeAssignParm } from "./shared/wsMealAssignmentMealSubsidyTypeAssignParm";
import { wsMealAssignmentStudentListInfo } from "./shared/wsMealAssignmentMealSubsidyTypeAssignParm";

import { ViewChild } from "@angular/core";

@Component({
	selector: "app-root",
	templateUrl: "./mealassignment.component.html",
	styleUrls: ["./mealassignment.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class MealAssignmentComponent implements OnInit, OnDestroy {
	@ViewChild("Assigneddt") Assigneddt: Table;
	@ViewChild("UnAssigneddt") UnAssigneddt: Table;

	constructor(
		private datepipe: DatePipe,
		private dataService: DataService_mealassignment,
		private userService: UserService,
		private personselectorService: PersonSelectorService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isShowInfo1: boolean = false;
	public isShowInfo2: boolean = false;

	//	Person Selector
	private subscriptionPersonSelect: Subscription;
	private subscriptionPersonSelectMultiple: Subscription;
	private subscriptionSchoolSelect: Subscription;

	public lstSelectedPerson: any = []; // For Person Selector
	public SelectedSchool: any; // For Person Selector
	public PrevSelectedSchool: any; // For Person Selector

	//	MealSubsidy List
	public lstMealSubsidyType: wsMealAssignmentMealSubsidyTypeInfo[] = [];
	public SelectedMealSubsidyType: wsMealAssignmentMealSubsidyTypeInfo;
	public isMealSubsidysLoaded: boolean = false;
	public MealSubsidyTypeDesc: string;
	public MealSubsidyPct: number;

	//	Assignment Lists
	public rMealAssignments: wsMealAssignmentStudentDataInfo;

	public lstUnAssigned: wsMealAssignmentStudentUnassignedInfo[] = [];
	public lstUnAssignedChecked: wsMealAssignmentStudentUnassignedInfo[] = [];

	public lstAssigned: wsMealAssignmentStudentAssignedInfo[] = [];
	public lstAssignedChecked: wsMealAssignmentStudentAssignedInfo[] = [];

	//	DataTable page counts
	public pagefirstU: number = 0;
	public pagerowsU: number = 10;
	public pagefirstA: number = 0;
	public pagerowsA: number = 25;

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.subscriptionPersonSelectMultiple = this.personselectorService.onSelectedMultiplePersons().subscribe((lstperson: any) => {
			this.lstSelectedPerson = lstperson;
			this.onRefresh();
		});

		this.subscriptionSchoolSelect = this.personselectorService.onSchoolSelectedChange().subscribe((school) => {
			let isSchoolChange: boolean = false;

			this.PrevSelectedSchool = this.SelectedSchool;
			this.SelectedSchool = school;

			if (this.PrevSelectedSchool == null || this.PrevSelectedSchool.SchoolID != this.SelectedSchool.SchoolID) {
				isSchoolChange = true;
			}

			if (isSchoolChange == true && this.SelectedSchool.SchoolID > 0) {
				this.OnGetMealSubsidys();
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.subscriptionPersonSelectMultiple.unsubscribe();
		this.subscriptionSchoolSelect.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	OnGetMealSubsidys
	//
	//-----------------------------------------------------------------------------------------------------
	OnGetMealSubsidys() {
		if (this.isMealSubsidysLoaded == false) {
			this.isBusy = true;
			this.dataService.MealAssignmentMealSubsidyTypeSelectList().subscribe((data) => this.MealAssignmentMealSubsidyTypeSelectList_Complete(data));
		} else {
			this.onRefresh();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MealAssignmentMealSubsidyTypeSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	MealAssignmentMealSubsidyTypeSelectList_Complete(data: any) {
		this.isMealSubsidysLoaded = true;
		this.lstMealSubsidyType = data;

		this.SelectedMealSubsidyType = this.lstMealSubsidyType[0];
		this.MealSubsidyTypeDesc = this.SelectedMealSubsidyType.MealSubsidyTypeDesc;
		this.MealSubsidyPct = this.SelectedMealSubsidyType.MealSubsidyPct;

		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onMealSubsidyTypeChange
	//
	//-----------------------------------------------------------------------------------------------------
	onMealSubsidyTypeChange(e: any) {
		this.MealSubsidyTypeDesc = this.SelectedMealSubsidyType.MealSubsidyTypeDesc;
		this.MealSubsidyPct = this.SelectedMealSubsidyType.MealSubsidyPct;

		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRefresh
	//
	//-----------------------------------------------------------------------------------------------------
	onRefresh() {
		let lstSelected: wsMealAssignmentSelectedStudentsInfo[] = [];

		if (this.lstSelectedPerson.length > 0) {
			//
			//	Get the selected person list from person selector {lstSelected}
			//
			this.lstSelectedPerson.forEach((item) => {
				let r: wsMealAssignmentSelectedStudentsInfo = {
					PersonID: item,
				};

				lstSelected.push(r);
			});
		}

		//
		//	Unselect Items In Person Selector
		//
		//this.personselectorService.UnselectItems();

		//
		//	Get Data
		//
		let parms: wsMealAssignmentStudentDataParmInfo = {
			SchoolID: this.SelectedSchool.SchoolID,
			MealSubsidyTypeID: this.SelectedMealSubsidyType.MealSubsidyTypeID,
			SelectedItems: lstSelected,
		};

		this.isBusy = true;
		this.dataService.MealAssignmentStudentAssignmentDataGet(parms).subscribe((data) => this.MealAssignmentStudentAssignmentDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MealAssignmentStudentAssignmentDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	MealAssignmentStudentAssignmentDataGet_Complete(data: any) {
		this.lstUnAssignedChecked = [];
		this.lstAssignedChecked = [];

		this.rMealAssignments = data;
		this.lstUnAssigned = this.rMealAssignments.UnassignedItems;
		this.lstAssigned = this.rMealAssignments.AssignedItems;

		//
		//	Reset Sort
		//
		this.UnAssigneddt.multiSortMeta = [];
		this.UnAssigneddt.multiSortMeta.push({ field: "LastName", order: 1 });
		this.UnAssigneddt.sortMultiple();

		this.Assigneddt.multiSortMeta = [];
		this.Assigneddt.multiSortMeta.push({ field: "LastName", order: 1 });
		this.Assigneddt.sortMultiple();

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo1
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo1() {
		this.isShowInfo1 = !this.isShowInfo1;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo2
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo2() {
		this.isShowInfo2 = !this.isShowInfo2;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {
		this.lstUnAssignedChecked = [];
		this.lstAssignedChecked = [];
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAssign
	//
	//-----------------------------------------------------------------------------------------------------
	onAssign() {
		if (this.lstUnAssignedChecked.length > 0) {
			let parms: wsMealAssignmentMealSubsidyTypeAssignParm = {
				MealSubsidyTypeID: this.SelectedMealSubsidyType.MealSubsidyTypeID,
				SelectedItems: [],
			};

			this.lstUnAssignedChecked.forEach((item) => {
				let r: wsMealAssignmentStudentListInfo = {
					PersonID: item.PersonID,
				};

				parms.SelectedItems.push(r);
			});

			this.isBusy = true;
			this.dataService
				.MealAssignmentStudentMealSubsidyTypeAssign(parms)
				.subscribe((data) => this.MealAssignmentStudentMealSubsidyTypeAssign_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MealAssignmentStudentMealSubsidyTypeAssign_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	MealAssignmentStudentMealSubsidyTypeAssign_Complete(data: any) {
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUnassign
	//
	//-----------------------------------------------------------------------------------------------------
	onUnassign() {
		if (this.lstAssignedChecked.length > 0) {
			let parms: wsMealAssignmentMealSubsidyTypeAssignParm = {
				MealSubsidyTypeID: this.SelectedMealSubsidyType.MealSubsidyTypeID,
				SelectedItems: [],
			};

			this.lstAssignedChecked.forEach((item) => {
				let r: wsMealAssignmentStudentListInfo = {
					PersonID: item.PersonID,
				};

				parms.SelectedItems.push(r);
			});

			this.isBusy = true;
			this.dataService
				.MealAssignmentStudentMealSubsidyTypeUnAssign(parms)
				.subscribe((data) => this.MealAssignmentStudentMealSubsidyTypeUnAssign_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	MealAssignmentStudentMealSubsidyTypeUnAssign_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	MealAssignmentStudentMealSubsidyTypeUnAssign_Complete(data: any) {
		this.onRefresh();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
